import { useMemo } from 'react';
import type { Address } from '@sg/graphql-schema';

import type { AddressForm } from '../../address.config';
import { getAddressDuplicateByLocation } from '../../utils';

/**
 * Returns a memoed result of address duplication by location.
 */
export function useAddressDuplicateByLocation(
  props: AddressDuplicateByLocationProps,
) {
  const { addressId, addressForm, addresses } = props;

  return useMemo(() => {
    return getAddressDuplicateByLocation({
      addresses,
      addressToCheck: { ...addressForm, id: addressId },
    });
  }, [addressId, addressForm, addresses]);
}

// ─── Types ─────────────────────────────────────────────────────────────

type AddressDuplicateByLocationProps = Readonly<{
  addressId?: string;
  addressForm?: AddressForm;
  addresses: ReadonlyArray<Partial<Address>>;
}>;
